
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/university/diversify",
      function () {
        return require("private-next-pages/university/diversify.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/university/diversify"])
      });
    }
  